module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_3.19ded743.woff";